export default class LoginController {
    constructor($scope, $location, $window, $cookies, Flash, loginDaisyService) {
        this.$scope = $scope;
        this.$location = $location;
        this.$cookies = $cookies;
        this.$window = $window;

        this.Flash = Flash;
        this.loginDaisyService = loginDaisyService;

        this.boot();
    }

    boot() {
        this.isAuthenticated = ( this.$cookies.get('user') !== undefined);
        this.user = {
            login: '',
            password: '',
            plant: ''
        };

        this.loginDaisyService.getPlants().then((response) => {
            this.plants = response;
        });

        $(document).ready(this.initJQuery);
    }

    findPosition(searchArray, value, keyName = 'id') {
        return _.findIndex(searchArray, [keyName, value]);
    }

    changedUserPlant(plantId){
        let plantPosition = this.findPosition(this.plants, parseInt(plantId), 'PLANT_ID');
        let newPlant = false;
        if (plantPosition !== -1){
            newPlant = this.plants[plantPosition];
        }
        this.user.plant = newPlant;
    }

    changedUserName(userName){
        if (userName != ''){
            this.loginDaisyService.getUserPlant(userName).then((response) => {
                if (response.PLANT_ID == 0){
                    this.user.plant = '';
                    return;
                }
                this.user.plant = response;
            });
        }
    }

    login(user){
        this.loginDaisyService.login(user.login, user.password, user.plant.PLANT_ID).then((response) => {
            if (response == false){
                return;
            }
            this.$cookies.putObject('user', response);
            this.isAuthenticated = true;
            this.Flash.create('success', 'Erfolgreich angemeldet');

            this.$location.path('/packaging');
        });
    }

    logout(){
        this.$cookies.remove('user');
        this.isAuthenticated = false;

        this.Flash.create('success', 'Erfolgreich abgemeldet');
    }

    goToLocation(locationString){
        this.$location.path('/' + locationString);
    }

    reload(){
        this.$window.location.reload();
    }

    initJQuery(){
        var keyboardPosition = {
            of: $('.keyboard-container'),
            my : 'center top',
            at : 'center top',
            at2: 'center bottom'
        };

        $('.vrkeyboardnum').keyboard({
            layout: 'customnum',
            autoAccept : true,
            position: keyboardPosition
        });
    }
}